import React, { useEffect, useRef, useState } from 'react';
import ProductList from '../../views/PartnerView/ProductList';
import ProductView from '../../views/PartnerView/ProductView';
import { useServiceContext } from '../Context/ServiceContext';
import { useParams } from 'react-router-dom';
import EditProduct from '../../views/PartnerView/EditProduct';
import { useBranchContext } from '../Context/BranchContext';
import { usePartnerContext } from '../Context/PartnerContext';

const ProductListComponent = () => {
    const userType = localStorage.getItem('userType');
    const [loading, setLoading] = useState(true);
    const didFetch = useRef(false);
    const { GetProductByPartner, GetAllProduct } = useServiceContext();
    const { FetchBranches } = useBranchContext();
    const { FetchProductCategories } = usePartnerContext();
    const { id, edit } = useParams();

    const getData = async () => {
        try {
            if (userType === 'ADMIN') {
                await GetAllProduct();
            } else {
                await GetProductByPartner();
            }
            if (edit === 'true') {
                await FetchBranches();
                await FetchProductCategories();
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
            getData();
            didFetch.current = true;
        }
    });

    return (
        <div>
            {id && edit ? (
                !loading && (edit === 'false' ? <ProductView /> : <EditProduct />)
            ) : (
                !loading && <ProductList />
            )}
        </div>
    );
};

export default ProductListComponent;
